import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageWithBasePath from '../imageWithBasePath';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="dropdown language-dropdown">
      <button 
        className="btn py-0 px-1 btn-light btn-icon" 
        type="button"   
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
        {i18n.language === 'vi' ? (
          <ImageWithBasePath
            src="assets/img/flags/vn.png"
            alt="VN"
            className="flag-icon-sm rounded-circle"
            width={48}
            height={48}
          />
        ) : (
          <ImageWithBasePath
            src="assets/img/flags/gb.png"
            alt="EN"
            className="flag-icon-sm rounded-circle"
            width={48}
            height={48}
          />
        )}
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        <li>
          <button 
            className={`dropdown-item d-flex align-items-center ${i18n.language === 'en' ? 'active' : ''}`}
            onClick={() => changeLanguage('en')}
          >
            <ImageWithBasePath
              src="assets/img/flags/gb.png"
              alt="EN"
              className="flag-icon-md rounded-circle me-2"
              width={20}
              height={20}
            />
            English
          </button>
        </li>
        <li>
          <button 
            className={`dropdown-item d-flex align-items-center ${i18n.language === 'vi' ? 'active' : ''}`}
            onClick={() => changeLanguage('vi')}
          >
            <ImageWithBasePath
              src="assets/img/flags/vn.png"
              alt="VN"
              className="flag-icon-md rounded-circle me-2"
              width={20}
              height={20}
            />
            Tiếng Việt
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher; 